export const REDIRECT_TO_ANOTHER_PAGE = 'REDIRECT_TO_ANOTHER_PAGE';
export const INITIALIZE = 'INITIALIZE';
